module.exports = __webpack_public_path__ + "static/media/user_1.d7f6757f.png";